export const EMPLOYEE = 1
export const PARTNER = 2
export const EMPLOYER = 3
export const MODERATOR = 4
export const AGENT = 5
